import React from "react";
import { useLang } from "@/context/LanguageContext";
import { ShieldCheck, BadgeCheck } from "lucide-react";

// Renders role/verified badges for a community author or member.
// `badges` = { role, is_organizer, verified, is_pro, categories }
export default function AuthorBadges({ badges, className = "" }) {
  const { t } = useLang();
  if (!badges) return null;
  const chips = [];
  const cats = badges.categories || [];
  if (badges.role === "admin") chips.push(["team", "amber", true]);
  else if (badges.role === "official") chips.push(["official", "amber", true]);
  else {
    if (badges.is_organizer) chips.push(["organizer", "indigo", badges.verified]);
    if (cats.some((c) => ["artisan", "craft", "smith"].includes(c))) chips.push(["artisan", "emerald", badges.verified]);
    if (cats.some((c) => ["artist", "musician"].includes(c))) chips.push(["artist", "fuchsia", false]);
    if (badges.is_pro && !badges.is_organizer) chips.push(["pro", "sky", badges.verified]);
  }
  if (!chips.length) return null;
  const color = { amber: "text-amber-300 border-amber-700/50 bg-amber-950/40", indigo: "text-indigo-300 border-indigo-700/50 bg-indigo-950/40", emerald: "text-emerald-300 border-emerald-700/50 bg-emerald-950/40", fuchsia: "text-fuchsia-300 border-fuchsia-700/50 bg-fuchsia-950/40", sky: "text-sky-300 border-sky-700/50 bg-sky-950/40" };
  return (
    <span className={`inline-flex items-center gap-1 flex-wrap ${className}`}>
      {chips.slice(0, 2).map(([kind, c, verified], i) => (
        <span key={i} data-testid={`badge-${kind}`} className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[9px] font-mono uppercase tracking-wider border ${color[c]}`}>
          {(kind === "team" || kind === "official") ? <ShieldCheck className="w-3 h-3" /> : verified ? <BadgeCheck className="w-3 h-3" /> : null}
          {t(`com_badge_${kind}`)}{verified && kind !== "team" && kind !== "official" ? ` · ${t("com_badge_verified")}` : ""}
        </span>
      ))}
    </span>
  );
}
